import React, {useEffect, useState} from "react";
import {ISelect} from "@/components/Select/helper";
import './index.less'

interface Props{
    stat: ISelect[]
    params: any
    setParams: any
    fields: string
}

const QuickFilter = (props: Props) => {
    const [active,setActive] = useState<number>(0)
    const {stat = [],params,setParams,fields} = props
    useEffect(() => {
        if(!params.hasOwnProperty(fields) && active){
            setActive(0)
        }
    },[params])

    const onSelect = (item: ISelect,index: number) => {
        setActive(index)
        setParams({...params,[fields]: item.value})
    }

    return(
        <div className='mb10 mt10'>
            {stat.map((item: ISelect, index: number) =>
                <span key={index} className={`tab-item ${active == index ? "tab-item-active" : "tab-item-normal"}`}
                      onClick={() => onSelect(item, index)}>
                    {item.label} {item?.count && `(${item.count})` || ''}
                </span>
            )}
        </div>
    )
}
export default QuickFilter